var map = {
	"./404.svg": 974,
	"./Categories.png": 723,
	"./Edit-menu.svg": 975,
	"./Egg.svg": 976,
	"./Emaier-Header.png": 977,
	"./Qr-4.png": 978,
	"./_duplicate.svg": 979,
	"./_overview.svg": 980,
	"./add-white.svg": 981,
	"./alert.svg": 982,
	"./all_category.svg": 983,
	"./archive.svg": 984,
	"./armchair.svg": 985,
	"./arrow-circle-right.svg": 986,
	"./arrow-left-circle.svg": 987,
	"./arrow-right-circle.svg": 988,
	"./arrow-right.svg": 989,
	"./asc-up-white.svg": 990,
	"./asc.png": 991,
	"./asc.svg": 992,
	"./back-arrow.svg": 993,
	"./barcode-icon.svg": 994,
	"./beverages.svg": 995,
	"./blue-edit-pen.svg": 996,
	"./blue-eye.svg": 997,
	"./box-office.svg": 998,
	"./broken-seat.jpg": 999,
	"./calendar_list.svg": 1000,
	"./calender.svg": 368,
	"./chevron-down.svg": 1001,
	"./chevron-left.svg": 1002,
	"./cinema-mamagement-sidebar.svg": 1003,
	"./claendar.svg": 369,
	"./clock-1.svg": 1004,
	"./clock.svg": 1005,
	"./close-button.svg": 730,
	"./close-white.svg": 736,
	"./close-x.svg": 312,
	"./collapse-up.svg": 1006,
	"./collapse.svg": 1007,
	"./connection-lost.svg": 366,
	"./consumable-raw-material.svg": 1008,
	"./copy.svg": 1009,
	"./copy_image_icon.png": 1010,
	"./delete-red-light.svg": 1011,
	"./delete-red.svg": 737,
	"./delete.svg": 711,
	"./deliver-icon.svg": 1012,
	"./desc-down-white.svg": 1013,
	"./desc.svg": 1014,
	"./distributors-sidebar.svg": 1015,
	"./download.svg": 1016,
	"./dragndrop.svg": 1017,
	"./dragndrop2.svg": 1018,
	"./duplicate.svg": 1019,
	"./duplicateScreen.svg": 1020,
	"./e-wallet-icon-black.svg": 1021,
	"./edit-pen-blue.svg": 1022,
	"./edit-pen-white.svg": 1023,
	"./edit-pen.svg": 1024,
	"./edit.svg": 1025,
	"./email.png": 1026,
	"./empty-image.svg": 1027,
	"./excel.svg": 1028,
	"./external-link.svg": 1029,
	"./eye.svg": 1030,
	"./filter-icon.svg": 1031,
	"./flag.svg": 1032,
	"./fnb-app-order.svg": 1033,
	"./fnb-beverages.svg": 1034,
	"./fnb-brownie.svg": 1035,
	"./fnb-combo.svg": 1036,
	"./fnb-desert.svg": 1037,
	"./fnb-eatables.svg": 1038,
	"./fnb-make-your-combo.svg": 1039,
	"./fnb-popcorn.svg": 1040,
	"./fnbtransactionIcon.svg": 1041,
	"./fullscreen-icon.svg": 738,
	"./funnel.svg": 1042,
	"./globe.svg": 1043,
	"./green-tick.svg": 1044,
	"./grid-view.svg": 1045,
	"./hide-password.svg": 370,
	"./home-icon.svg": 1046,
	"./home.svg": 1047,
	"./icon-black-play.svg": 1048,
	"./icon-dot.svg": 1049,
	"./icon-fnb.svg": 1050,
	"./icon-marketing.svg": 1051,
	"./icon-no-seat.png": 1052,
	"./icon-no-seat.svg": 1053,
	"./icon-option.svg": 1054,
	"./icon-poin-of-sale.svg": 1055,
	"./icon-recliner.svg": 1056,
	"./icon-report.svg": 1057,
	"./icon-sofa-dark-1.svg": 1058,
	"./icon-sofa-dark.png": 1059,
	"./icon-sofa-dark.svg": 1060,
	"./icon-sofa.svg": 1061,
	"./importfile.svg": 1062,
	"./info.svg": 739,
	"./info2.svg": 1063,
	"./keyboard-icon.svg": 1064,
	"./kitchen_display.svg": 1065,
	"./language-icon.svg": 1066,
	"./left-caret.svg": 1067,
	"./link.svg": 1068,
	"./list-view.svg": 1069,
	"./loading.svg": 371,
	"./lock.svg": 1070,
	"./login-password.png": 372,
	"./login-user.png": 373,
	"./logout.svg": 740,
	"./masters-sidebar.svg": 1071,
	"./merchandise.svg": 1072,
	"./minus.svg": 1073,
	"./movie-pass-svg.svg": 721,
	"./movie-rolling.svg": 1074,
	"./mulitSchedule.svg": 1075,
	"./multicurrency.svg": 1076,
	"./multifnb.svg": 1077,
	"./nav-plus.svg": 1078,
	"./new_filter_icon.svg": 1079,
	"./no-image.svg": 1080,
	"./no-schedule.svg": 144,
	"./non-veg-mark.png": 1081,
	"./non-veg-mark.svg": 1082,
	"./notification.svg": 1083,
	"./open-link-blue.svg": 1084,
	"./openPlanned.svg": 1085,
	"./overview.svg": 1086,
	"./overview2.svg": 1087,
	"./pdf-icon.svg": 1088,
	"./pdf.svg": 1089,
	"./pickup-ticket-icon.svg": 1090,
	"./pickupfnb.svg": 1091,
	"./play.svg": 1092,
	"./plus.svg": 1093,
	"./pointofsale-1.svg": 1094,
	"./pointofsale-2.svg": 1095,
	"./pointofsale.png": 1096,
	"./portfolio.svg": 1097,
	"./pos-fnb-no-itmes.svg": 724,
	"./pos-refresh.svg": 1098,
	"./primary/chevron-down.svg": 1099,
	"./primary/download.svg": 1100,
	"./primary/edit.svg": 1101,
	"./primary/filter.svg": 1102,
	"./primary/printer.svg": 1103,
	"./print-icon.svg": 1104,
	"./print.svg": 1105,
	"./question.svg": 1106,
	"./question1.svg": 1107,
	"./question2.svg": 741,
	"./question3.svg": 1108,
	"./recliner-1.svg": 1109,
	"./recliner.png": 1110,
	"./refund-icon.svg": 1111,
	"./reload-icon-pos.svg": 1112,
	"./reload-icon.svg": 1113,
	"./restore.svg": 1114,
	"./right-caret.svg": 1115,
	"./role-management-sidebar.svg": 1116,
	"./save.svg": 1117,
	"./schedule-icon.svg": 1118,
	"./school-calendar.svg": 1119,
	"./search-global-white.svg": 1120,
	"./search-global.svg": 1121,
	"./search.svg": 742,
	"./searchIcon.svg": 1122,
	"./seat-icon-2.svg": 1123,
	"./seat-icon.svg": 1124,
	"./seat-icons/3-wheelChair.png": 1125,
	"./seat-icons/block_seat_new.png": 1126,
	"./seat-icons/broken-seat-1.svg": 1127,
	"./seat-icons/broken-seat-2.svg": 1128,
	"./select-food.png": 743,
	"./settings.svg": 1129,
	"./show-password.svg": 374,
	"./slider-triangle.svg": 733,
	"./snack.svg": 744,
	"./sort.svg": 1130,
	"./star-empty.svg": 1131,
	"./star-fill.svg": 1132,
	"./success-tick.svg": 1133,
	"./suitcase.svg": 1134,
	"./swap.svg": 1135,
	"./tick-green-item.svg": 745,
	"./tick-green.svg": 1136,
	"./ticket-icon.svg": 1137,
	"./trash.svg": 1138,
	"./unpaid-reservation.svg": 715,
	"./updown-white.svg": 1139,
	"./updown.svg": 1140,
	"./user-attribute.svg": 1141,
	"./user-attributes.svg": 1142,
	"./user-female.svg": 1143,
	"./user-male-white.svg": 1144,
	"./user-male.svg": 1145,
	"./user-profile.svg": 1146,
	"./userProfile.png": 1147,
	"./veg-food-mark-white.png": 1148,
	"./veg-foog-mark-trans.png": 1149,
	"./view.png": 1150,
	"./view.svg": 1151
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 973;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons ^\.\/.*$
// module id = 973
// module chunks = 38